<template>
  <v-row :style="{ height: `${height}px` }">
    <v-col cols="8">
      <v-row class="h-100">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="d-flex pa-1 bg">
              <div class="mr-auto d-flex">
                <span class="px-1">{{ `${$t('sod.ttl.ra')} ${$t('common.list')}` }}</span>
              </div>
              <div class="mr-auto d-flex">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-text-field
                  v-model="ra.srchNm" :placeholder="this.$t('sod.filter.ra.nm')"
                  class="text-full-width" outlined dense hide-details clearable
                />
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="ml-2" x-small color="primary" @click="fetchRaList()">
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('common.retrieve') }}</span>
                </v-tooltip>
              </div>
              <div class="top-button-group">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="mr-2" x-small right color="primary" @click="addRa">
                      <v-icon small>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('common.add') }}</span>
                </v-tooltip>
              </div>
            </v-card-title>
            <v-card-text class="pa-0">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                v-model="ra.selected" :headers="raHeaders" :items="ra.items" item-key="raId"
                :options.sync="ra.options" :items-per-page="ra.paging.rowsPerPage" :loading="ra.loading"
                class="elevation-1 content" fixed-header dense hide-default-footer single-select :height="raListHeight"
                @click:row="raHighlight"
              >
                <template #item.riskLevel="{ item }">
                  <div class="color-cell" :style="riskLevelColorStyle(item.riskLevel)">
                    {{ $t(`sod.risk.level.${item.riskLevel}`) }}
                  </div>
                </template>
                <template #item.riskType="{ item }">{{ $t(`sod.risk.type.${item.riskType}`) }}</template>
                <template #item.isActive="{ item }">
                  <v-simple-checkbox :value="item.isActive ? true : false" disabled></v-simple-checkbox>
                </template>
                <template #item.actions="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-icon
                        v-on="on" small class="mr-2" color="primary"
                        @click="editRa(item)"
                      >
                        mdi-pencil-box-multiple-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('common.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-icon
                        v-on="on" small color="primary"
                        :disabled="item.isSstm == 1 ? true : false"
                        @click="deleteRa(item)"
                      >
                        mdi-trash-can-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('common.delete') }}</span>
                  </v-tooltip>
                </template>
                <template #footer>
                  <pagination :paging.sync="ra.paging" :length="ra.length" :disabled="ra.loading" />
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <ra-form v-show="ra.showForm" :ra-id="ra.selectedId" @close="closeRaForm" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="4">
      <v-row class="h-100">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="d-flex pa-1 bg">
              <div class="mr-auto d-flex">
                <span class="px-1">{{ $t('sod.ttl.ra') }}</span>
                <span class="px-1" v-show="existRaNm">{{ `(${ra.item.raNm})` }}</span>
                <span class="px-1">{{ `${$t('sod.ttl.auth')} ${$t('common.list')}` }}</span>
              </div>
              <div class="top-button-group">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <v-btn
                      v-on="on" class="mr-2" x-small right color="primary"
                      :disabled="ra.selectedId == 0 || ra.item.isSstm == 1"
                      @click="addRaAuth"
                    >
                      <v-icon small>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('common.add') }}</span>
                </v-tooltip>
              </div>
            </v-card-title>
            <v-card-text class="pa-0">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-data-table
                v-model="auth.selected" :headers="authHeaders" :items="auth.items" item-key="authId"
                :items-per-page="auth.paging.rowsPerPage" :loading="auth.loading"
                class="elevation-1 content" fixed-header dense hide-default-footer single-select :height="authListHeight"
                @click:row="authHighlight"
              >
                <template #item.actions="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-icon
                        v-on="on" small class="mr-2" color="primary"
                        :disabled="ra.item.isSstm == 1"
                        @click="editRaAuth(item)"
                      >
                        mdi-pencil-box-multiple-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('common.edit') }}</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <!-- eslint-disable-next-line prettier/prettier -->
                      <v-icon
                        v-on="on" small color="primary"
                        :disabled="ra.item.isSstm == 1"
                        @click="deleteRaAuth(item)"
                      >
                        mdi-trash-can-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('common.delete') }}</span>
                  </v-tooltip>
                </template>
                <template #footer>
                  <pagination :paging.sync="auth.paging" :length="auth.length" :disabled="auth.loading" />
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <ra-auth-form v-show="auth.showForm" :ra-id="ra.selectedId" :auth-id="auth.selectedId" @close="closeRaAuthForm" />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';

import RaForm from './RaForm.vue';
import RaAuthForm from './RaAuthForm.vue';

export default {
  components: {
    RaForm,
    RaAuthForm,
  },
  props: {
    height: {
      type: Number,
    },
  },
  data() {
    return {
      ra: {
        loading: false,
        item: {},
        items: [],
        showForm: false,
        showFormMode: '',
        selectedId: 0,
        selected: [],
        srchNm: '',
        length: 0,
        paging: { page: 1, rowsPerPage: 50 },
        options: { sortBy: ['raNm'], sortDesc: [false] },
      },
      auth: {
        loading: false,
        items: [],
        showFormMode: '',
        showForm: false,
        selectedId: 0,
        selected: [],
        srchNm: '',
        length: 0,
        paging: { page: 1, rowsPerPage: 50 },
      },
    };
  },
  computed: {
    raListHeight() {
      // RaForm이 보여졌을 때 그 높이가 154임.
      if (this.ra.showForm) return this.height - 80 - 154;
      else return this.height - 80;
    },
    authListHeight() {
      if (this.auth.showForm) return this.height - 80 - 150;
      else return this.height - 80;
    },
    raHeaders() {
      return [
        { text: this.$t('sod.ttl.id'), value: 'raId', width: '70px', sortable: true, align: 'right' },
        { text: this.$t('sod.ttl.ra') + ' ' + this.$t('sod.ttl.nm'), value: 'raNm', sortable: true },
        { text: this.$t('sod.ttl.risk.level'), value: 'riskLevel', width: '100px', sortable: true, align: 'center' },
        { text: this.$t('sod.ttl.risk.type'), value: 'riskType', width: '100px', sortable: false },
        { text: this.$t('sod.ttl.desc'), value: 'raDesc', sortable: false },
        { text: this.$t('sod.ttl.is.active'), value: 'isActive', width: '80px', sortable: false, align: 'center' },
        { text: '', value: 'actions', width: '74px', sortable: false, align: 'center' },
      ];
    },
    authHeaders() {
      return [
        { text: this.$t('sod.ttl.id'), value: 'authId', width: '70px', sortable: false, align: 'right' },
        { text: this.$t('sod.ttl.auth.obj') + ' / ' + this.$t('sod.ttl.prfl'), value: 'authObj', sortable: false },
        { text: this.$t('sod.ttl.auth.fld'), value: 'authFld', sortable: false },
        { text: this.$t('sod.ttl.auth.val'), value: 'authVal', sortable: false },
        { text: '', value: 'actions', width: '74px', sortable: false, align: 'center' },
      ];
    },
    existRaNm() {
      return !isEmpty(this.ra.item.raNm);
    },
  },
  watch: {
    'ra.selectedId': {
      handler(val) {
        this.auth.showForm = false;
        if (val == 0) this.auth.item = {};
        else this.fetchRaAuthList();
      },
    },
  },
  methods: {
    riskLevelColorStyle(riskLevel) {
      if (riskLevel == 'H') return 'color: #FF9800';
      else if (riskLevel == 'M') return 'color: #FF6F00';
      else if (riskLevel == 'L') return 'color: #E65100';
      else return 'color: #FFEB3B';
    },
    raHighlight(item, { isSelected, select }) {
      select(!isSelected);
      // 선택이 됐을 때.
      if (!isSelected) {
        this.ra.selectedId = item.raId;
        this.ra.item = item;
        /*
         * "edit" 버튼이 클릭됐을 때에도, data-table의 row가 선택된다.
         * 물론 "edit" 버튼의 @click 이벤트를 @click.stop 처리해주면 data-table의 row가 선택되는 행위는 발생하지 않는다.
         * 하지만, "edit" 버튼이 클릭됐을 때 해당 row가 선택되어야 한다.
         * 그러면서도, RaForm이 보여진 상태에서 다른 row가 선택되면 RaForm이 닫히게 하고 싶다.
         * 아래 두 줄은 그러한 로직을 구현한 것이다.
         * 참고로, this.ra.showFormMode에 'EDIT'를 할당하는 행위는 "edit" 버튼이 클릭됐을 때 이루어진다.
         */
        if (this.ra.showFormMode != 'EDIT') this.ra.showForm = false;
        this.ra.showFormMode = '';
      }
    },
    addRa() {
      this.ra.selectedId = 0;
      this.ra.selected = [];
      this.ra.showForm = true;
    },
    /**
     * selectedId가 RaForm에 props 'raId'로 전달되고,
     * RaForm은 props 'raId'가 변했을 때 반응하게 작성되었으므로,
     * selectedId가 변경되도록 0을 할당했다가 다시 선택된 raId를 할당해준다.
     */
    editRa(item) {
      this.ra.selectedId = 0;
      // this.ra.selectedId를 바로 바꾸어 주면
      // RaForm 쪽에서 watcher 'raId'의 reactivity가 동작하지 않으므로
      // 약간의 delay를 준다.
      this.$nextTick(() => {
        this.ra.selectedId = item.raId;
      });
      this.ra.showFormMode = 'EDIT';
      this.ra.showForm = true;
    },
    async deleteRa(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        const { status } = await api.delete('/sod/ra', { data: { raId: item.raId } });
        if (status === 200) {
          this.$dialog.info(this.$t('common.successful'));
          this.fetchRaList();
          this.ra.selectedId = 0;
        }
      }
    },
    closeRaForm(optn) {
      this.ra.showForm = false;
      if (optn == 'save') this.fetchRaList();
    },
    async fetchRaList() {
      this.ra.loading = true;
      const params = { raNm: this.ra.srchNm };
      params.page = this.ra.paging.page;
      params.limit = this.ra.paging.rowsPerPage;
      const {
        data: { items, pagination },
      } = await api.get('/sod/ra-list', { params });
      this.ra.items = items;
      this.ra.length = pagination.totalCount;
      this.ra.loading = false;
    },

    authHighlight(item, { isSelected, select }) {
      select(!isSelected);
      // 선택이 됐을 때.
      if (!isSelected) {
        this.auth.selectedId = item.authId;
        if (this.auth.showFormMode != 'EDIT') this.auth.showForm = false;
        this.auth.showFormMode = '';
      }
    },
    addRaAuth() {
      this.auth.selectedId = 0;
      this.auth.selected = [];
      this.auth.showForm = true;
    },
    /**
     * selectedId가 하위 컴포넌트에 props 'authId'로 전달되고,
     * 하위 컴포넌트들은 props 'authId'가 변했을 때 반응하게 작성되었으므로,
     * selectedId가 변경되도록 0을 할당했다가 다시 선택된 authId를 할당해준다.
     */
    editRaAuth(item) {
      this.auth.selectedId = 0;
      // this.auth.selectedId를 바로 바꾸어 주면
      // RaAuthForm 쪽에서 watch 'authId'의 reactivity가 동작하지 않으므로
      // 약간의 delay를 준다.
      this.$nextTick(() => {
        this.auth.selectedId = item.authId;
      });
      this.auth.showFormMode = 'EDIT';
      this.auth.showForm = true;
    },
    async deleteRaAuth(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        const { status } = await api.delete('/sod/ra-auth', { data: { authId: item.authId } });
        if (status === 200) {
          this.$dialog.info(this.$t('common.successful'));
          this.fetchRaAuthList();
          this.auth.selectedId = 0;
        }
      }
    },
    closeRaAuthForm(optn) {
      this.auth.showForm = false;
      if (optn == 'save') this.fetchRaAuthList();
    },
    async fetchRaAuthList() {
      this.auth.loading = true;
      const params = { raId: this.ra.selectedId };
      params.page = this.auth.paging.page;
      params.limit = this.auth.paging.rowsPerPage;
      const {
        data: { items, pagination },
      } = await api.get('/sod/ra-auth-list', { params });
      this.auth.items = items;
      this.auth.length = pagination.totalCount;
      this.auth.loading = false;
    },
  },
  created() {
    this.fetchRaList();
    this.fetchRaAuthList();
  },
};
</script>

<style lang="scss" scoped>
.text-full-width {
  width: 360px;
  margin-bottom: 3px;
}
.color-cell {
  width: 100%;
  height: 15px;
}
</style>
